<mat-form-field appearance="outline" class="wide filter" [class.active]="filterText?.length !== 0">
    <mat-label>{{ title }}</mat-label>
    <input matInput type="text" [(ngModel)]="filterText" (keyup)="fireEvent()" />
</mat-form-field>
